export default __webpack_public_path__ + "static/media/ThaiHealth-2.778da422.png";